import PropTypes from "prop-types";

import styled from "styled-components/macro";

import FnrIcon from "UI/FnrIcon";
import { FnrToggleChild } from "UI/FnrToggle2";
import { TabBackground, TabText, TabWrapper } from "UI/tabBarStyles";

GivingTab.propTypes = {
  setGivingTab: PropTypes.func,
  givingTab: PropTypes.string,
  givingTabKey: PropTypes.string,
  text: PropTypes.string,
  icon: PropTypes.string,
  colors: PropTypes.object,
};

export default function GivingTab({
  setGivingTab,
  givingTab,
  givingTabKey,
  text,
  icon,
  colors,
}) {
  const handleClick = () => {
    setGivingTab(givingTabKey);
  };

  return (
    <Wrapper onClick={handleClick}>
      <FnrToggleChild
        selected={givingTab === givingTabKey}
        style={{ flexGrow: 0 }}
      >
        <TabBackground style={{ fontSize: 20 }} colors={colors}>
          <FnrIcon icon={icon} />
          <TabText>{text}</TabText>
        </TabBackground>
      </FnrToggleChild>
    </Wrapper>
  );
}

const Wrapper = styled(TabWrapper)`
  font-weight: 400;
  & ${TabText} {
    font-size: 18px;
  }
`;
